export const apiUrl = process.env.REACT_APP_API_URL;
export const tokenUrl = process.env.REACT_APP_TOKEN_URL;
export const MaxFileUploadSize = 5242880; // 5 MB

